module.exports = __webpack_public_path__ + "static/img/akum_800_240.1275a2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_240.svg
// module id = hQW6
// module chunks = 1